export default "__VITE_ASSET__Bx5fzuCU__"